import type { Sprint } from '../../model/index.tsx';
import getActiveSprints from '../../rest/get-active-sprints/index.tsx';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default async (boardId: string): Promise<Sprint[]> => {
	const activeSprints = await getActiveSprints(boardId);
	return activeSprints.values;
};
